import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/private_label_package.jpg";
import singleSheet from "../../Assets/single-sheet.png";
import oceanPlastic from "../../Assets/ocean-plastic.png";
import privateLabelLaundrySheets from "../../Assets/private-label-laundry-sheets.png";
import Tilt from "react-parallax-tilt";
import SocialMedia from "../SocialMedia/SocialMedia";
import HomeWhy from "../WhyKlean/WhyKlean";
import HomeCompact from "../CompactDesign/CompactDesign";
import BuiltForYou from "../BuiltForYou/BuiltForYou";
import TextCarousel from "../TextCarousel/TextCarousel";
import RefillBanner from "../RefillBanner/RefillBanner";

function HomeContent() {
  const buyerTypes = [
    "Retail brands",
    "E-commerce brands",
    "Refill shops",
    "Subscription brands",
    "Distributors and wholesalers",
    "Eco-home product lines",
  ];

  return (
    <>
      <Container fluid className="home-about-section primary-bg left">
        <Container className="inner-container">
          <Row>
            <Col md={4}>
                <Tilt>
                  <img src={myImg} className="img-fluid" alt="Private label laundry detergent sheet packaging sample" />
                </Tilt>
            </Col>
            <Col md={4} className="numbered-items-column white">
              <div className="numbered-item">
                <div className="circle primary">01</div>
                <h4>Private Label Support</h4>
              </div>
              <div className="numbered-item">
                <div className="circle primary">02</div>
                <h4>35-45 Day Lead Time</h4>
              </div>
              <div className="numbered-item">
                <div className="circle primary">03</div>
                <h4>Columbus Sample Support</h4>

              </div>
            </Col>

            <Col md={4} className="sample-sheet">
              <Tilt>
                <img src={singleSheet} className="img-fluid" alt="Perforated laundry detergent sheet for half sheet or full sheet use" />
              </Tilt>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="home-about-section" >
        <Container className="inner-container left primary">
          <h2 className="home-about-title left">Private Label Laundry Sheets Built for Your Brand</h2>
          <Row className="home-about-content">
    
            <Col md={7} className="left home-about-feature mt-4">
             <p>
              Klean Leaf helps business buyers launch and scale laundry detergent sheets under their own brand. We support custom formula and scent development, compact perforated sheet formats, eco-friendly packaging customization, bulk manufacturing, and delivery coordination from factory production through final shipment.
             </p>
             <div>Core services include:</div>
             <ul>
              <li>Private label laundry detergent sheets</li>
              <li>Bulk manufacturing for brands, wholesalers, and retailers</li>
              <li>Custom scent, fragrance-free, and formula development</li>
              <li>Paper bag, paper box, custom packaging, and bulk refill carton options</li>
              <li>Manufacturing, packaging, logistics, and delivery support</li>
             </ul>
             <strong>Columbus, Ohio business support | Global manufacturing and logistics</strong>
            </Col>
            <Col md={5}>
              <div className="private-label-image-wrapper">
                <img
                  src={privateLabelLaundrySheets}
                  className="img-fluid private-label-image"
                  alt="Private label laundry detergent sheets with custom brand packaging"
                />
              </div>
            </Col>
          </Row>
          <a href="/contact" className="primary-btn mt-3">Start Your Private Label Project</a>
        </Container>
      </Container>

      <Container fluid className="home-about-section white left">
        <Container className="inner-container primary">
          <h2 className="home-about-title left">Who We Help</h2>
          <p>
            Our programs are designed for companies sourcing finished laundry sheet products, not for direct-to-consumer one-off orders.
          </p>
          <Row className="b2b-grid">
            {buyerTypes.map((type) => (
              <Col md={4} sm={6} key={type} className="b2b-grid-item">
                <h3>{type}</h3>
                <p>Source private label, wholesale, refill, or custom laundry sheet formats that match your sales channel.</p>
              </Col>
            ))}
          </Row>
          <div className="cta-row">
            <a href="/solution" className="secondary-btn">Explore B2B Solutions</a>
            <a href="/contact" className="primary-btn">Get a Custom Quote</a>
          </div>
        </Container>
      </Container>

      <HomeWhy />
      <HomeCompact />
      <BuiltForYou />
      <RefillBanner />
      <TextCarousel />

      <Container fluid className="home-about-section primary left  mt-5">
        <Container>
          <h2>
            Our Responsibility:
          </h2>
          <img src={oceanPlastic} className="img-fluid plastic-ocean" alt="Plastic laundry detergent jugs near ocean water" />
          <p className="mt-5">
          Laundry sheets give brands a compact alternative to heavy liquid detergent formats. For B2B buyers, that can mean easier storage, lighter cartons, more efficient shipping, and packaging formats that fit refill, retail, and e-commerce channels.
          </p>

          <Row>
            <Col md={12} className="home-about-social center primary">
              <h2>FIND US ON</h2>
              <p>Feel free to connect with us</p>
              <SocialMedia />
              <a
                href="mailto:hello@kleanleaf.us"
                style={{ textDecoration: "none", color: "#134b4e" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>hello@kleanleaf.us</p>
              </a>
              <a
                href="tel:614-906-5129"
                style={{ textDecoration: "none", color: "#134b4e" }}
              >
                <p>614.906.5129</p>
              </a>
            </Col>
          </Row>
        </Container>
      </Container>

    </>
  );
}
export default HomeContent;
